/**
 * 获取元素y轴的滚动距离
 * @param el 如果不指定元素，获取当前窗口
 */
function getScrollTop(el = null) {
    if (!el) {
        return document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    }
    return el.scrollTop;
}
/**
 * 获取元素的滚动高度
 * @param el 如果不指定元素，获取当前窗口
 */
function getScrollHeight(el = null) {
    if (!el) {
        return document.documentElement.scrollHeight || document.body.scrollHeight;
    }
    return el.scrollHeight;
}
export { getScrollTop, getScrollHeight };
